const formatProductUrl = (url) => url.replace(/^\//, '') + '.js';

class CardProductInfo extends HTMLElement {
  constructor() {
    super();
    this.currentVariant = null;
    this.available = false;
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  connectedCallback() {
    this.inputId = this.querySelector('product-form input[name="id"]');
    this.inputsVariants = this.querySelectorAll('fieldset.product-form__input');
    this.buttonAddToCart = this.querySelector('button[name="add"]');
    this.scriptProductInfo = this.querySelector('script[data-card-product-info]');
    this.currentVariant = JSON.parse(this.scriptProductInfo.textContent).variants[0];
    this._attachEventListeners();
  }

  _attachEventListeners() {
    this.inputsVariants.forEach((fieldset) => {
      const inputs = fieldset.querySelectorAll('input[type="radio"]');
      inputs.forEach((input) => {
        input.addEventListener('change', (event) => this._handleVariantChange(event));
      });
    });
    this.buttonAddToCart.addEventListener('click', (event) => this._handleFormSubmit(event));
  }

  getVariantByTitle(title) {
    return JSON.parse(this.scriptProductInfo.textContent).variants.find((variant) => variant.public_title === title);
  }

  _handleVariantChange(event) {
    event.preventDefault();
    if (this.currentVariant.public_title === event.target.value) return;
    this.currentVariant = this.getVariantByTitle(event.target.value);
    const productUrl = event.target.getAttribute('data-product-url');
    const formattedUrl = formatProductUrl(productUrl);
    this._fetchInfo(formattedUrl);
  }

  _fetchInfo(productUrl) {
    fetch(`${window.Shopify.routes.root}${productUrl}`)
      .then((response) => response.json())
      .then((product) => {
        this._updateInfoState(product);
        this._updateAddToCartButton(product);
      })
      .catch((error) => console.error('Error fetching product information:', error));
  }

  _updateInfoState(product) {
    this.scriptProductInfo.textContent = JSON.stringify(product);
    this.inputId.value = this.currentVariant.id;
    this.currentVariant = product.variants.find((variant) => variant.public_title === this.currentVariant.public_title);
    this.available = this.currentVariant.available;
  }

  _updateAddToCartButton() {
    const textAvailable = this.buttonAddToCart.getAttribute('data-text-available');
    const textSoldOut = this.buttonAddToCart.getAttribute('data-text-sold-out');
    this.buttonAddToCart.children[0].textContent = this.available ? textAvailable : textSoldOut;
    this.buttonAddToCart.disabled = !this.available;

    if (!this.available) {
      this.buttonAddToCart.setAttribute('aria-disabled', true);
    } else {
      this.buttonAddToCart.removeAttribute('aria-disabled');
    }
  }

  _handleFormSubmit(event) {
    /* event.preventDefault();
    if (!this.available) return;
    const formData = {
      id: this.currentVariant.id,
      quantity: 1,
    };

    fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('Success:', data);
      })
      .finally(() => {
        if (this.cart && this.cart.classList.contains('is-empty')) {
          this.cart.setActiveElement(document.activeElement);
          this.cart.classList.remove('is-empty');
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      }); */
  }
}

customElements.define('card-product-info', CardProductInfo);
